// extracted by mini-css-extract-plugin
export default {"wrapper":"Birthday_wrapper__uM+tw"};